import React from 'react';
import avatarIMG from '../../assets/images/avatarImg.png';
import SocialLogo from './SocialLogo';
import verified from '../../assets/svg/experience/verified.svg';
import ThemeSwitcher from '../ThemeSwitcher';

const ProfileCard = () => {
   return (
      <div
         id="profile"
         className="relative flex flex-col items-center pb-6 animate-fadeUp"
      >
         {/* Banner */}
         <div className="relative w-full h-44 sm:h-52 overflow-hidden rounded-b-3xl">
            <div className="absolute inset-0 bg-gradient-to-tr from-indigo-600 via-violet-600 to-emerald-500" />
            <div
               className="absolute inset-0 opacity-30 mix-blend-overlay"
               style={{
                  backgroundImage:
                     'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.6) 0, transparent 35%), radial-gradient(circle at 80% 60%, rgba(0,0,0,0.4) 0, transparent 40%)',
               }}
            />
            {/* Top bar */}
            <div className="relative z-10 flex items-start justify-between p-4 sm:p-5">
               <div className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur px-3 py-1.5 text-[11px] font-semibold tracking-wide text-white ring-1 ring-white/20">
                  <span className="relative flex h-2 w-2">
                     <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-300 opacity-75" />
                     <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
                  </span>
                  Available for work
               </div>
               <ThemeSwitcher />
            </div>

            {/* Floating decorative dots */}
            <div className="absolute -bottom-6 left-10 h-12 w-12 rounded-2xl bg-white/10 ring-1 ring-white/20 backdrop-blur animate-float" />
            <div className="absolute top-8 right-20 h-8 w-8 rounded-full bg-white/15 ring-1 ring-white/20 backdrop-blur animate-float [animation-delay:1.5s]" />
         </div>

         {/* Avatar */}
         <div className="-mt-14 sm:-mt-16 relative" id="about">
            <div className="absolute -inset-1 rounded-2xl bg-gradient-to-tr from-emerald-400 to-indigo-500 blur-md opacity-70" />
            <img
               src={avatarIMG}
               alt="Tanbir Hossen Sarkar"
               className="relative h-28 w-28 sm:h-32 sm:w-32 rounded-2xl object-cover ring-4 ring-white dark:ring-zinc-950 shadow-soft"
            />
            <span className="absolute bottom-1 right-1 h-4 w-4 rounded-full bg-emerald-500 ring-2 ring-white dark:ring-zinc-950" />
         </div>

         {/* Name + meta */}
         <div className="mt-5 flex flex-col items-center px-5 text-center">
            <h1 className="font-display text-2xl sm:text-[28px] font-bold tracking-tight flex items-center gap-2">
               Tanbir Hossen Sarkar
               <img src={verified} alt="" className="h-5 w-5" />
            </h1>
            <p className="mt-1 text-[12px] sm:text-[13px] font-semibold tracking-[0.18em] uppercase text-zinc-500 dark:text-zinc-400">
               MOBILE APP &amp; SECURITY DEVELOPER
            </p>

            <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
               <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500/10 px-3 py-1 text-[11px] font-semibold text-emerald-600 dark:text-emerald-400 ring-1 ring-emerald-500/20">
                  Founder · FixBuild Core X
               </span>
               <span className="inline-flex items-center gap-1.5 rounded-full bg-indigo-500/10 px-3 py-1 text-[11px] font-semibold text-indigo-600 dark:text-indigo-400 ring-1 ring-indigo-500/20">
                  Android Apps · App Security
               </span>
               <span className="inline-flex items-center gap-1.5 rounded-full bg-violet-500/10 px-3 py-1 text-[11px] font-semibold text-violet-600 dark:text-violet-400 ring-1 ring-violet-500/20">
                  Kotlin · Java · C · Go · C++
               </span>
               <span className="inline-flex items-center gap-1.5 rounded-full bg-zinc-500/10 px-3 py-1 text-[11px] font-semibold text-zinc-600 dark:text-zinc-300 ring-1 ring-zinc-500/20">
                  Dhaka, BD
               </span>
            </div>

            {/* CTA */}
            <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
               <a href="#contact" className="btn-primary">
                  Get in touch
                  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                     <path d="M5 12h14" />
                     <path d="M13 5l7 7-7 7" />
                  </svg>
               </a>
               <a href="#projects" className="btn-ghost">View Projects</a>
            </div>

            {/* Socials */}
            <div className="mt-5 flex items-center gap-3">
               <SocialLogo />
            </div>
         </div>
      </div>
   );
};

export default ProfileCard;
